import Admin from "./Admin";
import QuotesList from "./QuotesList";
import ShipmentsActiveList from "./ShipmentsActiveList";
import QuotesDismissedList from "./QuotesDismissedList";
import ShipmentsCompletedList from "./ShipmentsCompletedList";
import ContainerPadded from "../ContainerPadded";
import ShipmentDetails from "./ShipmentDetails";
import ShipmentEdit from "./ShipmentEdit";

export const AdminRouteIds = {
    adminDashboard: 0,
    quotes: 1,
    shipments: 2,
    quotesDismissed: 3,
    shipmentsCompleted: 4
}

const AdminRoutes = [
  {
    index: true,
    path: '/admin',
    title: 'Admin Dashboard',
    requireAuth: true,
    element: <ContainerPadded><Admin /></ContainerPadded>,
    id: AdminRouteIds.adminDashboard,
    displayInNav: true
  },
  {
    path: '/admin/quotes',
    title: 'Quotes',
    requireAuth: true,
    element: <ContainerPadded><QuotesList /></ContainerPadded>,
    id: AdminRouteIds.quotes,
    displayInNav: true
  },
  {
    path: '/admin/quotes/dismissed',
    title: 'Dismissed Quotes',
    requireAuth: true,
    element: <ContainerPadded><QuotesDismissedList /></ContainerPadded>,
    id: AdminRouteIds.quotesDismissed,
    displayInNav: true
  },
  {
    path: '/admin/shipments',
    title: 'Active Shipments',
    requireAuth: true,
    element: <ContainerPadded><ShipmentsActiveList /></ContainerPadded>,
    id: AdminRouteIds.shipments,
    displayInNav: true
  },
  {
    path: '/admin/shipments/active/:trackingNumber',
    title: 'Shipment Details',
    requireAuth: true,
    element: <ContainerPadded><ShipmentDetails adminMenuId={AdminRouteIds.shipments} canEdit={true} /></ContainerPadded>,
    id: AdminRouteIds.shipments,
    displayInNav: false
  },
  {
    path: '/admin/shipments/edit/:trackingNumber',
    title: 'Edit Shipment',
    requireAuth: true,
    element: <ContainerPadded><ShipmentEdit /></ContainerPadded>,
    id: AdminRouteIds.shipments,
    displayInNav: false
  },
  {
    path: '/admin/shipments/completed',
    title: 'Completed Shipments',
    requireAuth: true,
    element: <ContainerPadded><ShipmentsCompletedList /></ContainerPadded>,
    id: AdminRouteIds.shipmentsCompleted,
    displayInNav: true
  },
  {
    path: '/admin/shipments/completed/:trackingNumber',
    title: 'Shipment Details',
    requireAuth: true,
    element: <ContainerPadded><ShipmentDetails adminMenuId={AdminRouteIds.shipmentsCompleted} canEdit={false} /></ContainerPadded>,
    id: AdminRouteIds.shipmentsCompleted,
    displayInNav: false
  }
];

export default AdminRoutes;
